// extracted by mini-css-extract-plugin
module.exports = {"LeverandoerSide":"LeverandoerSide_LeverandoerSide__3W9CA","dato":"LeverandoerSide_dato__3JaZD","beskrivelse":"LeverandoerSide_beskrivelse__2pdRb"};